export default __webpack_public_path__ + "static/media/male-8.ed4264ce.jpg";